<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Title-->
    <header-component :headerTitle="headerText" />

    <!-- Update popup -->
    <v-row justify="center">
      <v-dialog v-model="updatePopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Confirmation</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="updatePendingConfirmationCancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-autocomplete color="primary" v-model="return_method" variant="outlined" :items="returnList" label="Return Method"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <v-menu ref="menu_141" v-model="menu_141" :close-on-content-click="false" :return-value="returnDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ props }">
                      <v-text-field color="primary" variant="outlined" hide-details v-model="formattedReturnDate" label="Return Date" prepend-inner-icon="mdi-calendar" readonly v-bind="props"></v-text-field>
                    </template>
                    <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                      <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="isDatePickerReturnDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                      </v-date-picker>
                      <v-card-action class="d-flex justify-end pb-3">
                        <v-spacer></v-spacer>
                        <v-btn variant="text" color="primary" @click="menu_141 = false">Cancel</v-btn>
                        <v-btn variant="text" color="primary" @click="handleSaveDate('menu_141', 'returnDate', 'isDatePickerReturnDate')">OK</v-btn>
                      </v-card-action>
                    </v-card>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="mb-3 bg-blue text-none" @click="updatePendingConfirmationSubmit" :disabled="number > 0">Submit</v-btn>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="updatePendingConfirmationCancel">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-data" v-model="filterPopup" persistent max-width="1224px">
        <v-card style="max-width: 100% !important;" class="filter_ui">
          <v-card-actions v-if="active_tab === 'Pending Confirmation' || active_tab === 'Dispatch'">
            <v-row>
              <v-col>
                <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="article_id_search" label="Article Id" class="ma-2" variant="outlined"></v-text-field>
              </v-col>
              <v-col>
                <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" v-model="brand_selected" variant="outlined" :items="brandList" label="Brand" class="ma-2" multiple></v-autocomplete>
              </v-col>
              <v-col>
                <v-autocomplete color="primary" 
                   prepend-inner-icon="mdi-magnify" 
                   v-model="vendor_selected" 
                   variant="outlined" 
                   :items="vendorList" 
                    item-title="vendor_name" 
                    item-value="vendor_code" 
                    label="Vendor" 
                    class="ma-2" 
                    :loading="isLoading" 
                    @keyup="handleKeyEnter($event)"></v-autocomplete>
              </v-col>
               <v-col>
                <v-autocomplete  color="primary"
                  v-model="putaway_filter" variant="outlined" :items="puttawayList"
                   label="Putaway Status" class="ma-2">
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="normal" class="text-none" @click="closeFilterpopup">Cancel</v-btn>
            <v-btn size="small" variant="flat" class="text-none" color="primary" @click="applyFilterFunc">Apply Filter(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Approve Ok confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="okapproveconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approvalConfirmationCancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="white" class="mb-3 bg-blue" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <DownloadPopup 
      ref="downloadPopup"
      v-model:visible="downloadDialog" 
      :api-endpoint="getApiEndpoint()"
      :payload="payload"
      @show-alert="handleShowAlert"
      method="get"
      @success="handleSuccess"
    />

    <!-- Header -->
    <v-card class="v-card-100 mt-6">
    <v-tabs color="primary" v-model="selected_tab" class="mt-6">
      <v-tab ripple @click="loadData(tab, 'tab_clicked')" style="text-transform:none!important;text-decoration: none;padding-top: 4px;" class="tab-color" v-for="(tab, index) in tabs" :key="index">
        {{ tab }}
      </v-tab>
    </v-tabs>
    </v-card>

    <!-- search, filter, Action buttons -->
      <v-card-title class="action-style" style="padding-left: 28px;">
      <v-row class="me-3 my-2">
        <!-- Search fields -->
          <v-combobox class="text-left mr-4" v-if="active_tab == 'Pending Confirmation' || active_tab == 'Dispatch' || active_tab == 'Pending For Approval'" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" 
            label="Select Field" variant="outlined" style="max-width: 158px;"> </v-combobox>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" color="primary" style="max-width: 300px;" variant="outlined" :disabled="!select_field && active_tab !== 'Pending Replacement'" v-on:keyup.enter="loadData(active_tab)" @input="handleLocationInput"></v-text-field>
            <v-spacer></v-spacer>
        <!-- Actions buttons -->
        <v-actions>
          <v-btn class="mr-2 text-none" variant="flat" size="x-large" :disabled="this.selected.length == 0 || $isRelianceClient()" v-if="active_tab == 'Pending Confirmation' && isActionAllowed(role)" color="primary" @click="updatedialog">Update Confirmation</v-btn>
          <v-btn class="mr-2 text-none" variant="flat" size="x-large" :disabled="table_data.length === 0" @click="downloadSelected()" v-if="active_tab == 'Pending Confirmation' && isActionAllowed(role)" color="primary">Download</v-btn>
          <v-btn class="mr-2 text-none" variant="flat" size="x-large" v-if="active_tab == 'Pending Confirmation' && $isRelianceClient() && isActionAllowed(role)"  :disabled="(selected.length != 0)" @click="navigateToFileUpload" color="primary">Upload</v-btn>
        </v-actions>

        <!-- Filter -->
        <v-expansion-panels v-if="active_tab == 'Pending Confirmation' || active_tab == 'Dispatch'"
          class="custom-control_outlined m-0" ref="filterPopupRef" readonly
          style="max-width: 300px;margin-bottom: 18px; height: 52px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px;">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-row>
      </v-card-title>

    <v-row justify="center">
      <v-dialog v-model="dataDetailPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID "{{ item_details.tag_number }}"</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closeDataDetailPopUp">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article ID</span>
                  </v-col>
                  <v-col cols="6" v-if="active_tab == 'Pending Confirmation' || active_tab == 'Pending Replacement'">
                    {{ item_details.sku_code ? item_details.sku_code : '-' }}
                  </v-col>
                  <v-col cols="6" v-if="active_tab == 'Dispatch'">
                    {{ item_details.article_id ? item_details.article_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6" v-if="active_tab == 'Pending Confirmation' || active_tab == 'Pending Replacement'">
                    {{ item_details.item_description ? item_details.item_description : '-' }}
                  </v-col>
                  <v-col cols="6" v-if="active_tab == 'Dispatch'">
                    {{ item_details.article_description ? item_details.article_description : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Pending Replacement'">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Price (₹)</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.item_price ? item_details.item_price.toLocaleString('en-IN')  : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab != 'Pending Replacement' || isDispatched == true">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Brand</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.brand ? item_details.brand : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab != 'Pending Replacement' || isDispatched == true">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Vendor</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.vendor ? item_details.vendor : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab != 'Pending Replacement' || isDispatched == true">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Approval Code</span>
                  </v-col>
                  <v-col cols="6" v-if="active_tab == 'Pending Confirmation' || active_tab == 'Pending Replacement'">
                    {{ item_details.approval_code ? item_details.approval_code : '-' }}
                  </v-col>
                  <v-col cols="6" v-if="active_tab == 'Dispatch'">
                    {{ item_details.approval_code_text ? item_details.approval_code_text : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Pending Confirmation'">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Status</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.confirmed_status ? item_details.confirmed_status : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Dispatch' || isDispatched == true">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Replacement Order Number</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.order_number ? item_details.order_number : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Dispatch' || isDispatched == true">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Replacement DC Number</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.replacement_dc_number ? item_details.replacement_dc_number : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Dispatch' || isDispatched == true">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Return Method</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.return_method ? item_details.return_method : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Dispatch' || isDispatched == true">
                  <v-col cols="6">
                    <span style="font-weight: 500;">Return Date</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.return_date ? item_details.return_date.split('-').reverse().join('/') : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Data Table -->
    <v-layout column v-if="active_tab == 'Pending Confirmation' || active_tab == 'Dispatch' || active_tab == 'Pending For Approval'">
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover 
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          fixed-header
          height="100%"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait" class="elevation-1"
          return-object
          >
          <template #[`header.disposition_age`]="{ column }">
            <span>{{ column.title }}
              <AgeingTooltip />
            </span>
          </template>
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
            <span v-if="header.key == 'tag_number'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key === 'return_date' && !item.update">
                <span>{{ item.return_date ? item.return_date.split('-').reverse().join('/') : "-" }}</span>
              </span>
              <span v-else-if="header.key === 'item_price' && !item.update">
                <span>{{ item.item_price ?  Number(item.item_price).toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.vendor`]="{ item }">
            <span>{{ item.vendor ? item.vendor : "-" }}</span>
          </template> -->
          <!-- <template #[`item.return_date`]="{ item }">
            <span>{{ item.return_date ? item.return_date.split('-').reverse().join('/') : "-" }}</span>
          </template> -->
          <!-- <template #[`item.approval_code`]="{ item }">
            <span>{{ item.approval_code ? item.approval_code : "-" }}</span>
          </template> -->
          <!-- <template #[`item.tag_number`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2;" class="cursor-pointer">
              <u> {{ item.tag_number }}</u>
            </a>
          </template> -->
          <!-- <template #[`item.item_price`]="{ item }">
            <span>{{ item.item_price ?  Number(item.item_price).toLocaleString('en-IN') : '-' }}</span>
          </template> -->
          <!-- <template #[`item.replacement_dc_number`]="{ item }">
            <span>{{ item.replacement_dc_number  ? item.replacement_dc_number   : "-" }}</span>
          </template>
          <template #[`item.sub_location_name`]="{ item }">
            <span>{{ item.sub_location_name ? item.sub_location_name : '-' }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>

    <div v-if="active_tab == 'Pending Replacement'">
      <v-row class="m-0">
        <v-col cols="6" sm="6" md="6"
          style="padding-right: 0px !important; border-right: 1px solid rgba(0,0,0,.26);">
          <v-layout>
            <v-col cols="12" style="overflow: auto">
              <div style="background-color:#0000000a; padding: 4px;" class="text-start">
                <span style="padding-left: 8px; padding-bottom: 8px;">Dispatched</span>
              </div>
              <v-data-table hover 
                density="compact"
                disable-pagination
                :headers="headersDispatched"
                :hide-default-footer="true"
                :items="dispatchItem"
                :loading="loading"
                loading-text="Loading Data... Please wait" class="elevation-0">
                <template #[`header.disposition_age`]="{ column }">
                  <span>{{ column.title }}
                    <AgeingTooltip />
                  </span>
                </template>
                <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                  <span v-if="header.key == 'tag_number'">
                    <a href="#" @click.prevent="newitemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
                  </span> 
                  <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                    <span v-tooltip="item[header.key]">
                      {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                    </span>
                  </span>
                  <span v-else-if="header.key == 'item_price' && !item.update">
                    <span>{{ item.item_price ? Number(item.item_price).toLocaleString('en-IN') : '' }}</span>
                  </span>
                  <span v-else>-</span>
                </template>
                <!-- <template #[`item.tag_number`]="{ item }">
                  <a @click="newitemDetailpopup(item)" style="color: #1976d2;" class="cursor-pointer">
                    <u> {{ item.tag_number }}</u>
                  </a>
                </template> -->
                <!-- <template #[`item.item_price`]="{ item }">
                  <span>{{ item.item_price ? Number(item.item_price).toLocaleString('en-IN') : '' }}</span>
                </template> -->
                <!-- <template #[`item.sub_location_name`]="{ item }">
                  <span>{{ item.sub_location_name ? item.sub_location_name : '-' }}</span>
                </template>  -->
                <template #bottom></template>
              </v-data-table>
            </v-col>
          </v-layout>
        </v-col>
        <v-col cols="6" sm="6" md="6" style="padding-left: 0px !important; border-left: 1px solid rgba(0,0,0,.26)">
          <v-layout>
            <v-col cols="12" style="overflow: auto">
              <div style="background-color: #0000000a; padding: 4px;" class="text-start">
                <span style="padding-left: 8px; padding-bottom: 8px;">Replacement</span>
              </div>
              <v-data-table hover 
                density="compact"
                :headers="headersReplacement"
                disable-pagination
                :hide-default-footer="true"
                :items="replacementItem"
                :loading="loading"
                loading-text="Loading Data... Please wait"
                class="elevation-0">
                <template #[`header.disposition_age`]="{ column }">
                  <span>{{ column.title }}
                    <AgeingTooltip />
                  </span>
                </template>
                <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                  <span v-if="header.key == 'tag_id'">
                    <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
                  </span> 
                  <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                    <span v-tooltip="item[header.key]">
                      {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                    </span>
                  </span>
                  <span v-else>-</span>
                </template>
                <!-- <template #[`item.tag_id`]="{ item }">
                  <a @click="itemDetailpopup(item)" style="color: #1976d2;">
                    <u> {{ item.tag_number }}</u>
                  </a>
                </template> -->
                <template #bottom></template>
              </v-data-table>
            </v-col>
          </v-layout>
        </v-col>
      </v-row>
    </div>

    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
    
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
import { mixinHelper } from "@//mixins/mixin-helper.js";
import DownloadPopup from '../../../../commoncomponents/DownloadPopup.vue';
import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
// import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';
export default {
  mixins: [mixinHelper],
  components: {
    HeaderComponent, DownloadPopup
  },

  data() {
    return {
      headerText: "Replacement",
      tabs: [
        "Pending Confirmation",
        "Dispatch",
        "Pending Replacement",
        "Pending For Approval"
      ],
      search_tag: '',
      alert_type: 'info',
      alert: false,
      alert_message: '',
      selected_tab: 0,
      table_data: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      active_tab: "Pending Confirmation",
      selected: [],
      search: '',
      filterPopup: false,
      tag_id_search: '',
      article_id_search: '',
      updatePopup: false,
      number: 0,
      return_method: null,
      returnList: ["Dispatch", "Handover"],
      returnDate: '',
      isDatePickerReturnDate: new Date(),
      okapproveconfirmpopup: false,
      headers: [],
      headersDispatched: [],
      headersReplacement: [],
      articleList: [],
      brandList: [],
      vendorList: [],
      dataDetailPopup: false,
      item_details: '',
      dispatchItem: [],
      replacementItem: [],
      message: [],
      menu_141: false,
      isDispatched: false,
      brand_selected: '',
      vendor_selected: '',
      isLoading: false,
      isFilteringPage: false,
      filterPageNo: 1,
      select_field_items: [
      {
        "name":"Tag ID",
        "id": "tag_number"
      },
      {
        "name":"Serial Number",
        "id": "serial_number"
      },
      {
        "name":"IRD Number",
        "id": "ird_number"
      },
      {
        "name":"IRRD Number",
        "id": "irrd_number"
      }
      ],
      select_field:null,
      putaway_filter:null,
      puttawayList:["Pending","Completed"],
      downloadDialog: false,
      payload: {}
    }
  },

  async created() {
    this.scrollToTop();
    this.role = this.$store.state.currentUser.roles[0]
    if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Replacement')){
      signout()
      return;
    }
    this.organization_name = this.$store.state.organization_name
    const tab = this.$store.state.active_tab
    if(tab == 'Pending Replacement'){
      this.selected_tab = 2
      this.loadData('Pending Replacement');
    } else if(tab == 'Dispatch'){
      this.selected_tab = 1
      this.loadData('Dispatch');
    } else {
      this.selected_tab = 0
      this.loadData('Pending Confirmation');
    }
  },

  computed: {
    formattedReturnDate() {
      const dateParts = this.returnDate.split('-').reverse();
      return dateParts.join('/');
    },
  },
  watch: {
      selected(newVal) {
        if (this.active_tab === 'Pending Confirmation') {
          const putawayInward = newVal.filter(insurances => insurances.is_putaway_inwarded === false)
          const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
          if (putawayInward.length > 0) {            
            this.$nextTick(() => {
              this.showAlert("warning", "Please complete Putaway Process");
              this.selected = [];
            });
          }else if(isUnderPhysicalInspection.length > 0){
            this.$nextTick(() => {
              this.showAlert("warning", "Action on item blocked as it is under cycle count process");
              this.selected = [];
            });
          }
        }
      },
  }, 
  methods: {
    isActionAllowed(){
      return !isOnlyViewAction(this.role, 'Replacement')
    },
    scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
    // show Alert messages
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    loadData(tab, tab_clicked) {
      if (tab_clicked) {
        this.select_field = null;
        this.search_tag = '';        
      }
      this.loading = true;
      this.selected = []
      this.active_tab = tab
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.isFilteringPage = false
      this.filterPageNo = 1
      this.$store.commit('setActiveTab',{
        'active_tab' : tab
      })
      this.select_field_items = [
              {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"Serial Number",
                "id": "serial_number"
              },
              {
                "name":"IRD Number",
                "id": "ird_number"
              },
              {
                "name":"IRRD Number",
                "id": "irrd_number"
              }
          ];
      if (tab == "Pending Confirmation") {
        (this.headers = [
          { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth: "200px" },
          { title: "Article ID", key: "sku_code", minWidth: "200px" },
          { title: "Article Description", key: "item_description", minWidth: "200px" },
          { title: "Brand", key: "brand", minWidth: "200px" },
          { title: "Vendor", key: "vendor", minWidth: "200px" },
          { title: "Approval Code", key: "approval_code", minWidth: "200px" },
          { title: "Status", key: "confirmed_status", minWidth: "200px" },
          { title: "Date for Dispatch", key: "return_date", minWidth: "200px" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Sub-Location", key:"sub_location_name"},
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
        ]);
        this.fetchPendingConfirmation();
      } else if (tab == "Dispatch") {
        (this.headers = [
          { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth: "200px" },
          { title: "Brand", key: "brand", minWidth: "200px" },
          { title: "Vendor", key: "vendor", minWidth: "200px" },
          { title: "Replacement Order Number", key: "order_number", minWidth: "270px" },
          { title: "Replacement DC Number", key: "replacement_dc_number", minWidth: "270px" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Status", key: "status", minWidth: "200px" },
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"},
          { title: "Serial Number ", key: "serial_number" },
        ]);
        this.fetchDispatch();
      } else if (tab == "Pending For Approval") {
        this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
          this.select_field_items = [
             {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"Lot ID",
                "id": "lot_id"
              },
              {
                "name":"Publish ID",
                "id": "publish_id"
              },
              {
                "name":"Pending at",
                "id": "pending_at"
              }];
        this.fetchPendingForApproval();
      }else {
        (this.headersDispatched = [
          { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth: "200px" },
          { title: "Article ID", key: "sku_code", minWidth: "200px" },
          { title: "Price (₹)", key: "item_price", minWidth: "200px" },
          { title: "Ageing", key:"disposition_age", minWidth: "200px"},
          { title: "Sub-Location", key:"sub_location_name", minWidth: "200px"},
        
        ]);
        (this.headersReplacement = [
          { title: "Tag ID", align: "start", sortable: false, key: "tag_number", minWidth: "200px" },
          { title: "Article ID", key: "sku_code", minWidth: "200px" },
          { title: "Price (₹)", key: "item_price", minWidth: "200px" },
          { title: "Ageing", key:"disposition_age", minWidth: "200px"},
          { title: "Sub-Location", key:"sub_location_name", minWidth: "200px"}
        ]);
        this.fetchReplacement();
      }
    },

    fetchReplacement() {
      const params = {
        tag_number: this.search_tag,
        page: this.page,
        per_page: this.pageSize,
        status: this.active_tab,
      };
      this.$httpSecured
        .get("/api/v1/warehouse/replacements", { params: params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.replacements
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.loading = false;
            this.dispatchItem = [];
            this.replacementItem = [];
            for (let i = 0; i < this.table_data.length; i++) {
              if (this.table_data[i].has_replacement_order) {
                if (this.table_data[i].item_replaced) {
                  this.replacementItem.push(this.table_data[i]);
                } else {
                  this.dispatchItem.push(this.table_data[i]);
                }
              }
            }
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    fetchPendingConfirmation() {
      this.getVendorList('');
      const params = {
        page: this.page,
        per_page: this.pageSize,
        status: this.active_tab,
      };
      if(this.search_tag){
        params[this.select_field.id] = this.search_tag.trim()
      }
      this.$httpSecured
        .get("/api/v1/warehouse/replacements", { params: params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.replacements
            this.brandList = response.data.replacements.map(x => x.brand).filter((value, index, self) => self.indexOf(value) === index)
            // this.vendorList = response.data.replacements.map(x => x.vendor)
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.brandList.sort()
            // this.vendorList.sort()
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });

    },

    fetchDispatch() {
      this.getVendorList('');
      const params = {
        page: this.page,
        per_page: this.pageSize,
        status: this.active_tab,
      };
      if(this.search_tag){
        params[this.select_field.id] = this.search_tag.trim()
      }
      this.$httpSecured
        .get("/api/v1/warehouse/replacements/dispatch_items", { params: params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.warehouse_order_items
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.brandList = response.data.warehouse_order_items.map(x => x.brand)
            // this.vendorList = response.data.warehouse_order_items.map(x => x.vendor)
            this.brandList.sort()
            // this.vendorList.sort()
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    fetchPendingForApproval() {
      const params = {
        status: 'pending_approval',
        page: this.page,
        per_page: this.pageSize       
      };
      if(this.search_tag){
        params[this.select_field.id] = this.search_tag.trim()
      }
      this.$httpSecured
        .get("/api/v1/warehouse/replacements", { params: params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.replacements
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    handleKeyEnter(event) {
      this.getVendorList(event.target.value);
    },
    getVendorList(val) {
      this.isLoading = true;
      const params = {
        query: val,
      }
      this.$httpSecured
        .get("/api/v1/warehouse/new_repairs/get_vendor_master", { params: params })
        .then(response => {
          if (response.data) {
            this.isLoading = false;
            this.vendorList = response.data.vendor_masters
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    updatedialog() {
      const brands = this.selected.map(item => item.brand)
      const brondList = Array.from(new Set(brands));
      if (brondList.length > 1) {
        this.showAlert("warning", "Please select the items with same Brand!");
        this.selected = []
        return;
      }
      this.updatePopup = true;
      this.number = 0;
    },

    updatePendingConfirmationCancel() {
      this.number = 0;
      this.updatePopup = false;
      this.returnDate = '';
      this.return_method = '';
    },

    updatePendingConfirmationSubmit() {
      this.number++;
      const idsList = this.selected.map(x => x.id).join(', ');
      this.$httpSecured
        .put("/api/v1/warehouse/replacements/update_confirmation",
          {
            'ids': idsList,
            'return_method': this.return_method,
            'return_date': this.returnDate,
          })
        .then(response => {
          if (response.data) {
            this.message = response.data.message,
              this.message = this.message.replace(/'Updated'/g, '"Updated"'),
              this.okapproveconfirmpopup = true,
              this.loading = false;
            this.updatePendingConfirmationCancel();
          } else {
            this.loading = false;
            this.number = 0;
            this.$toast.error("error", "No Data Found");
          }
        })
        .catch(error => {
          this.number = 0;
          // this.showAlert("error", "Something went wrong from Network" + error);
          this.$toast.error(error.response.data.error)
          this.loading = false;
        });
    },

    approvalConfirmationCancel() {
      this.okapproveconfirmpopup = false;
    },

    afterClickOkLoadData() {
      this.okapproveconfirmpopup = false;
      this.loadData(this.active_tab);
    },

    closeFilterpopup() {
      this.filterPopup = false;
    },

    filterListOfButtons() {
      this.filterPopup = true;
      this.vendor_selected = null;
      this.article_id_search = '';
      this.brand_selected = null;
      this.putaway_filter = null;
    },

    handlePageChange(value) {
      this.page = value;
      if (this.isFilteringPage) {
        this.filterPageNo = value;
        this.applyFilterFunc();
        return;
      }
      if (this.active_tab == 'Pending Confirmation') {
        this.fetchPendingConfirmation();
      } else if (this.active_tab == 'Dispatch') {
        this.fetchDispatch();
      } else if(this.active_tab == 'Pending For Approval'){
        this.fetchPendingForApproval();
      } else {
        this.fetchReplacement();
      }
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1
      this.filterPageNo = 1;
      if (this.isFilteringPage) {
        this.applyFilterFunc();
        return;
      }
      if (this.active_tab == 'Pending Confirmation') {
        this.fetchPendingConfirmation();
      } else if (this.active_tab == 'Dispatch') {
        this.fetchDispatch();
      } else if(this.active_tab == 'Pending For Approval'){
        this.fetchPendingForApproval();
      } else {
        this.fetchReplacement();
      }
    },

    applyFilterFunc() {
      this.search_tag = ''
      this.filterPopup = false;
      this.loading = true;
      this.isFilteringPage = true;
      const params = {
        article_id: this.article_id_search,
        vendor_code: this.vendor_selected,
        // brand: (this.brand_selected.length > 1) ? this.brand_selected.join(',') : this.brand_selected[0],
        brand: (this.brand_selected && this.brand_selected.length > 1) ? this.brand_selected.join(',') : (this.brand_selected && this.brand_selected.length === 1) ? this.brand_selected[0] : '',
        putaway: this.putaway_filter,
        page: this.filterPageNo,
        per_page: this.pageSize,
        status: this.active_tab
      }
      if (this.active_tab == 'Pending Confirmation') {
        this.$httpSecured
          .get("/api/v1/warehouse/replacements", { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.replacements
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
              this.closeFilterpopup();
              this.selected = [];
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      } else if (this.active_tab == 'Dispatch') {
        this.$httpSecured
          .get("/api/v1/warehouse/replacements/dispatch_items", { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
              this.closeFilterpopup();
              this.selected = [];
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      }
    },
    newitemDetailpopup(item) {
      this.isDispatched = true;
      this.itemDetailpopup(item);
    },
    itemDetailpopup(item) {
      if (this.active_tab == 'Pending Confirmation' || this.active_tab == 'Pending Replacement') {
        this.dataDetailPopup = true;
        const id = item.id;
        this.$httpSecured
          .get("/api/v1/warehouse/replacements/" + id)
          .then(response => {
            if (response.data) {
              this.item_details = response.data.replacement
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      } else if (this.active_tab == 'Dispatch') {
        this.dataDetailPopup = true;
        const id = item.id;
        this.$httpSecured
          .get("/api/v1/warehouse/replacements/" + id + "/dispatch_item")
          .then(response => {
            if (response.data) {
              this.item_details = response.data.warehouse_order_item
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      }
    },
    closeDataDetailPopUp() {
      this.dataDetailPopup = false;
      this.isDispatched = false;
    },
    handleSaveDate(dateType , dateState, selectDateState) {
      this[dateState] = this.formatted_filter_date(this[selectDateState])
      this[dateType] = false
    },
    handleLocationInput() {
        this.Liquidation_search = (this.Liquidation_search || '').trim()
            .replace(/\s+/g, '')
            .replace(/[^a-zA-Z,\d-]/g, '');
    },
    navigateToFileUpload() {
        this.$store.commit("setLotIds", {
        lotIds: this.headerText,
        inventoryId: "Pending Confirmation",
        action:'first_tab'
      });       
      this.$router.push({ name: "LotFileuploadComm" });
    },
    downloadDocument() {
      const params = {
        status: 'Pending Confirmation',
        ids: this.selected.map(x => x.id).join(",")
      };
      this.$httpSecured
      .get("/api/v1/warehouse/replacements/download", { params: params })
      .then(response => {
        if (response.data) {
            const link = document.createElement("a");
            link.href = response.data.url;
            link.target = "_blank";
            link.download = "inventory.csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.okapproveconfirmpopup = true;
            this.message = this.active_tab + "(CSV File) Downloaded Successfully";
            this.selected = [];
        } else {
          this.loading = false;
          this.showAlert("error", "No Data Found");
          this.selected = [];
        }
      })
      .catch(error => {
        // this.showAlert("error", "Something went wrong from Network" + error);
        this.$toast.error(error.response.data.error);
      });
    },
    openPopup() {
        this.downloadDialog = true;
      },
      downloadSelected() {
        const type = this.selected.length === 0 ? 'submit' : 'selected';
        this.$refs.downloadPopup.downloadConfirmation(type);
      },
      getApiEndpoint() {        
        if (this.active_tab === 'Pending Confirmation') {
          this.payload = {
            status: "Pending Confirmation",
            ids: this.selected.map(x => (x.id))
          };
          return "/api/v1/warehouse/replacements/download";
        } else if (this.active_tab === 'Dispatch') {
          this.payload = {
            ids: this.selected.map(x => (x.id)),
            status: "Dispatch",
            is_download: true,
          };
          return "/api/v1/warehouse/replacements/dispatch_items";
        }else if(this.active_tab === 'Pending Replacement') {
          this.payload = {
            ids: this.selected.map(x => (x.id)),
            status: "Pending Replacement",
            is_download: true,
          };
          return "/api/v1/warehouse/replacements";
        } else {
          this.payload = {
            ids: this.selected.map(x => (x.id)),
            status: "pending_approval",
            is_download: true,
          };
          return "/api/v1/warehouse/replacements";
        }
      },
      handleSuccess(msg) {
        this.okapproveconfirmpopup = true;
        this.message = msg
      }
  },
}
</script>
<style scoped>
  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }

  .v-dialog:has(.filter-data) {
    justify-content: right;
    align-items: baseline;
    top: 13rem;
  }
  .item-selected {
    margin-top: 29px;
    position: absolute;
    left: 35%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 333px) !important;
  }
  .filter_ui{
    margin-right: 20px !important;
  }
</style>
    